import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { shallow } from 'zustand/shallow'

import { useAuthStore } from 'Store/Auth'
import RolePermissionConfigs from 'Configuration/RolePermission'
import useFetchSurveyDetail from './useFetchSurveyDetail'

const PAGES = [
  {
    label: 'ฟอร์มสำรวจ',
    pathSuffix: 'form',
  },
  {
    label: 'ใบขออนุมัติออกใบสั่งผลิต',
    pathSuffix: 'production-order-approval-form',
  },
  {
    label: 'ใบแจ้งเปิดงาน',
    pathSuffix: 'work-opening-notice',
  },
  {
    label: 'ไฟล์แนบ',
    pathSuffix: 'attachments',
  },
]

const useViewModel = () => {
  const { id } = useParams()
  const location = useLocation()
  const { survey } = useFetchSurveyDetail()
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)
  const userRoleId = profile?.roleId

  const visiblePages = useMemo(() => {
    const allPages = [...PAGES]
    if (
      userRoleId != null &&
      RolePermissionConfigs.survey_sales_attachment.includes(userRoleId)
    ) {
      allPages.push({
        label: 'ไฟล์แนบ(ฝ่ายขาย)',
        pathSuffix: 'sales-attachments',
      })
    }
    return allPages
  }, [userRoleId])

  const pages = useMemo(
    () =>
      visiblePages.map(page => {
        const href = `/survey/${id}/${page.pathSuffix}${location.search}`
        const pathWithoutSearch = location.pathname
        const isActive =
          pathWithoutSearch === `/survey/${id}/${page.pathSuffix}` ||
          (page.pathSuffix === 'form' && pathWithoutSearch === `/survey/${id}`)

        return {
          label: page.label,
          href,
          active: isActive,
        }
      }),
    [id, location.pathname, location.search, visiblePages]
  )

  return {
    id,
    pages,
    survey,
    isView: location.search.includes('view'),
  }
}

export default useViewModel
